$(function() {
    //IE11 Detection
    var IE11 = !!(navigator.userAgent.match(/Trident/) && navigator.userAgent.match(/rv[ :]11/));;
    if(IE11 === true){
        $('html').addClass('IE11');
    }

//Product Page Item description collapse and tabs
$(function () {
    const $tabLinksWrap = $('#tabs > .tab-links');
    const $tabFirstBtn = $tabLinksWrap.find('button').eq(0);

    $("#tabs > div").hide();
    $("#tabs > div:first").show();
    $tabFirstBtn.addClass('active');
    
    $tabLinksWrap.on('click', 'button', function () {
      const $this = $(this);
      const $sibling = $this.siblings();

      $sibling.removeClass('active').attr({
        'tabindex': '-1',
        'aria-selected': 'false'
      });

      $this.addClass('active').attr({
        'tabindex': '0',
        'aria-selected': 'true'
      });

      var currentTab = $this.attr('aria-controls');
      $("#tabs > div").hide();
      $(`#${currentTab}`).show();

      return false;
    });
  });
    $(function() {
        $('.item-image, .slider').flexslider({
            animation: "slide",
            animationLoop: false,
            useCSS: false
        });
    });
    if (document.body.classList.contains("pghome")) {
        function checkWidth() {
            var viewportWidth = document.documentElement.clientWidth;
            if (viewportWidth < 768) {
               
            } else {
               
            } 
        }
        checkWidth();
        window.addEventListener("resize", function(){
            checkWidth();
        });
    }
    
        /*Pinned Header */
        var offset = $( "header" ).offset();
        var sweepsOffset = $(".sweeps-banner").offset();
        checkOffset();
        $(window).on("scroll", function() {
            checkOffset();
        });
        function checkOffset() {
            if ( $(document).scrollTop() > offset.top){
                $('header').addClass('fixed');
                $('.logo-wrapper').removeClass('no-fix');
            } else {
                $('header').removeClass('fixed');
                $('.logo-wrapper').addClass('no-fix');
            } 
            if($("body div").hasClass("sweeps-banner")){
                if ( $(document).scrollTop() > offset.top){
                    $('.sweeps-banner').addClass('hidden-header');
                } else {
                    $('.sweeps-banner').removeClass('hidden-header');
                } 
            }
            if($("body div").hasClass("top-banner")){
                if ( $(document).scrollTop() > offset.top){
                    $('.top-banner').addClass('hidden-header');
                } else {
                    $('.top-banner').removeClass('hidden-header');
                } 
            }
        } 
}); 

$(function () {
    var $dropdowns = $("#main-nav .dropdown");
    var $dropdownsLinks = $("#main-nav .dropdownLink");
    $dropdownsLinks.on("focus",function(){
      let $thisParent = $(this).parent();
      $dropdowns.removeClass("open");
      $dropdownsLinks.attr("aria-expanded", "false");
      $thisParent.addClass("open");
      $(this).attr("aria-expanded", "true");
    })

    $('#main-nav').on("focusout", function() {
        setTimeout(() => {
          // if active element is outside the div.header-container...
          if ($(document.activeElement).parents('#main-nav').length === 0) {
            // remove hover functionality
            $dropdowns.removeClass("open");
            $dropdownsLinks.attr("aria-expanded", "false");
          }
        }, 100);
    })
}); 


//header elements positioning
$(function () {
    let desk = false
    let mob1 = false
    let mob2 = false
    function positionLayout() {
        if (window.matchMedia("(min-width:1441px)").matches) {
            //desk
            if (!desk) {
                $('.header-inner .main-nav').insertAfter('.header-inner .left-wrap');
            }
            desk = true
            mob1 = false
            mob2 = false
        } else if (window.matchMedia("(min-width:1025px)").matches) {
            //mob1
            if (!mob1) {
                $('.header-inner .main-nav').insertAfter('.header-inner .right-wrap');
            }
            desk = false
            mob1 = true
            mob2 = false
        } else {
            //mob2
            if (!mob2) {
                $('.header-inner .main-nav').insertBefore('.header-inner .logo-wrapper');
            }
            desk = false
            mob1 = false
            mob2 = true

        }
    }
    positionLayout()
    window.addEventListener('resize', positionLayout)

})